import { combineReducers } from "redux";
import * as peticioEnCursReducer from "./peticioEnCurs";
import * as indretsReducer from "./indrets";
import * as formulariReducer from "./formulari";
const rootReducer = combineReducers({
  peticioEnCurs: peticioEnCursReducer.default,
  dades: indretsReducer.default,
  formulari: formulariReducer.default
});

export default rootReducer;

export const getPeticioIndretsEnCurs = state =>
  peticioEnCursReducer.getPeticioEnCurs(state.peticioEnCurs);

export const getPeticioIndretsError = state => {
  peticioEnCursReducer.getPeticioError(state);
};

export const getIndretsLlistat = state =>
  indretsReducer.getIndretsLlistat(state.dades);

export const getIndretsAsArray = state =>
  indretsReducer.getIndretsAsArray(state.dades);

export const getIndretPerId = state =>
  indretsReducer.getIndretPerId(state.dades);

export const getDadesIndret = state =>
  indretsReducer.getDadesIndret(state.dades);

export const getIndretsActius = state =>
  indretsReducer.getIndretsActius(state.dades);

export const getIndretsInactius = state =>
  indretsReducer.getIndretsInactius(state.dades);

export const getIdIndret = state => indretsReducer.getIdIndret(state.dades);

export const getMostrarErrors = state => state.formulari.mostrarErrors;
export const getDadesEditades = state => state.formulari.editades;
export const getDadesOriginals = state => state.formulari.originals;
export const getPeticioEnviarFormulariIndretEnCurs = state =>
  state.formulari.peticioEnviarFormulariEnCurs;

export const getIndretFotosOriginals = state => state.formulari.fotos.originals;
export const getIndretFotosEliminades = state =>
  state.formulari.fotos.eliminades;
export const getIndretFotosCreades = state => state.formulari.fotos.creades;
